import { skuFreshRegex } from '@constants/common';

export const findFreshLine = (lines: ILineItem[] | undefined | null): ILineItem | undefined => {
  if (!lines || lines.length === 0) return undefined;

  const freshLine = lines.find(
    (line) => !line?.isOneTimeAdded && line?.sku && skuFreshRegex.test(line.sku),
  );
  if (freshLine) return freshLine;

  return lines.find((line) => !line?.isOneTimeAdded);
};

export const filterAdditionalLines = (lines: ILineItem[] | undefined | null): ILineItem[] => {
  if (!lines || lines.length === 0) return [];

  const freshLine = findFreshLine(lines);
  const visible = lines.filter((line) => !line?.isOneTimeRemoved);

  if (!freshLine) return visible;

  return visible.filter((line) => line !== freshLine);
};
